import { Link } from '@inertiajs/react'
import { MessageCircle } from 'lucide-react'
import { investigationUrl } from '@/frontend/features/Fde/investigations/format'
import type { InvestigationData, InvestigationRun } from '@/frontend/features/Fde/investigations/types'

export default function CoordinatorLink({ run, data }: { run: InvestigationRun; data: InvestigationData }) {
  if (!run.coordinator) return null
  return <Link href={investigationUrl(data.project.id, run.id, 'conversation')} method="post" as="button"
    data={{ conversation: {} }} className="inline-flex items-center gap-2 text-sm font-medium text-primary hover:underline">
    <MessageCircle className="size-4" aria-hidden />{data.labels.coordinator_chat.replace('%{name}', run.coordinator.name)}
  </Link>
}
